import * as Yup from 'yup';

export const validationSchema = Yup.object({
  title: Yup.string().required('Goal name is required'),
  description: Yup.string().required('Description is required'),
  scope: Yup.string().required('Scope is required'),
  associatedIds: Yup.mixed().when('scope', {
    is: (scope: string) => scope === 'ORG',
    then: () => Yup.mixed().notRequired().nullable(),
    otherwise: () =>
      Yup.array()
        .min(1, 'This field is required')
        .required('This field is required'),
  }),
  timeframe: Yup.string().required('Timeframe is required'),
  startDate: Yup.date().required('Start date is required'),
  endDate: Yup.date()
    .required('End date is required')
    .min(Yup.ref('startDate'), 'End date must be after start date'),
});
